import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FACC15",
            color: "#0A0A0A",
            border: "2px solid #0A0A0A",
            borderRadius: "0",
            fontWeight: 600,
            boxShadow: "4px 4px 0px #0A0A0A",
          },
        }}
      />
    </div>
  );
}

export default App;
